import {AbstractControl, ValidatorFn} from '@angular/forms';

import {TaxNumberValidatorKey} from './custom-validator-keys';

export function TaxNumberValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
        const value = (control.value && control.value.toString().trim());

        if (!value) {
            return null;
        }

        return !value.match(/^[a-zA-Z0-9.\-\/]+$/) ? {[TaxNumberValidatorKey]: true} : null;
    };
}
